import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox } from "@l2r-front/l2r-networks"
import { useUrlParams, NavigateWithParams } from "@l2r-front/l2r-utils"

import { RoadwayDetailSegmentSelectListener } from "../../containers/RoadwayDetailSegmentSelectListener"
import { RoadwayDetailSidebar } from "../../containers/RoadwayDetailSidebar"
import { RoadwaySidebar } from "../../containers/RoadwaySidebar"

export const RoadwayMobileRoutes = () => {
    const { getParams } = useUrlParams()

    const roadwayRoutes = useMemo(() => {
        const searchParams = getParams()

        return [
            {
                path: "/*",
                element:
                    <>
                        <MapAdapterBoundingBox />
                        <SegmentSelectListener />
                        <RoadwaySidebar />
                    </>,
            },
            {
                path: "/:road",
                element:
                    <>
                        <MapAdapterRoad />
                        <RoadwayDetailSegmentSelectListener />
                        <RoadwayDetailSidebar />
                    </>,
            },
            {
                path: "/:road/*",
                element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
            },
        ]
    }, [getParams])

    return useRoutes(roadwayRoutes)
}